import { render, staticRenderFns } from "./withdrawal_sh.vue?vue&type=template&id=63f48d8b&"
import script from "./withdrawal_sh.vue?vue&type=script&lang=js&"
export * from "./withdrawal_sh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports